import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-verloning',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-verloning.component.html',
  styleUrl: './tekst-verloning.component.scss',
})
export class TekstVerloningComponent {}
